import { useMutation, useQueryClient } from '@tanstack/react-query'
import { updateScannerSettings } from './updateScannerSettings'
import { QUERY_KEY_SETTINGS_SCANNER } from './useQueryScannerSettings'
import { ScannerSettingsPayload } from './types'

export function useMutationScannerSettings(companyId: string) {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (payload: ScannerSettingsPayload) => updateScannerSettings(companyId, payload),
    onSuccess: () =>
      queryClient.invalidateQueries({ queryKey: [QUERY_KEY_SETTINGS_SCANNER, companyId] }),
  })
}
